import { render, staticRenderFns } from "./category.vue?vue&type=template&id=6e5bc26f&scoped=true"
import script from "./category.vue?vue&type=script&lang=js"
export * from "./category.vue?vue&type=script&lang=js"
import style0 from "./category.vue?vue&type=style&index=0&id=6e5bc26f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5bc26f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e5bc26f')) {
      api.createRecord('6e5bc26f', component.options)
    } else {
      api.reload('6e5bc26f', component.options)
    }
    module.hot.accept("./category.vue?vue&type=template&id=6e5bc26f&scoped=true", function () {
      api.rerender('6e5bc26f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mall/category.vue"
export default component.exports